import React from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import { Calendar, Clock, User, ChevronRight } from 'lucide-react';

const OpdSchedule = () => {
  return (
    <>
      <Navbar />
      <div className="bg-gradient-to-b from-blue-50 to-white min-h-screen">
        {/* Hero Section */}
        <div className="bg-blue-700 text-white py-8 px-4 shadow-lg">
          <div className="max-w-6xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-bold mb-2">ट्रॉमा सेंटर एवं सुपरस्पेशिएलिटी हॉस्पिटल</h1>
            <h2 className="text-xl md:text-2xl font-medium mb-4">चिकित्सा विज्ञान संस्थान</h2>
            <div className="w-24 h-1 bg-yellow-400 mx-auto mb-4"></div>
            <p className="text-blue-100">An Institution of National Importance established by an Act of Parliament</p>
          </div>
        </div>
        
        {/* Main Content */}
        <div className="max-w-6xl mx-auto px-4 py-8">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 text-gray-800">
            OPD Schedule <span className="text-blue-600">/ बहिरंग रोगी अनुसूची</span>
          </h2>
          
          {/* Department Cards */}
          <div className="grid md:grid-cols-1 lg:grid-cols-1 gap-8">
            {/* Orthopedics Department */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden transition-transform hover:shadow-lg">
              <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-5 relative">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-2xl font-bold">DEPARTMENT OF ORTHOPEDICS</h3>
                    <p className="text-blue-100 mt-1 font-medium">अस्थिरोग बहिरंग</p>
                  </div>
                  <div className="bg-white text-blue-700 p-3 rounded-full shadow-lg">
                    <User size={24} />
                  </div>
                </div>
              </div>
              <div className="p-5">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead>
                      <tr className="bg-blue-50 text-blue-800">
                        <th className="py-3 px-4 text-left font-semibold rounded-l-lg border-b-2 border-blue-100">
                          <div className="flex items-center space-x-2">
                            <Calendar size={18} />
                            <span>DAY (दिन)</span>
                          </div>
                        </th>
                        <th className="py-3 px-4 text-left font-semibold rounded-r-lg border-b-2 border-blue-100">
                          <div className="flex items-center space-x-2">
                            <User size={18} />
                            <span>FACULTY (फैकल्टी)</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        { day: "Monday", dayHindi: "सोमवार", faculty: ["Prof. Ajit Singh", "Dr. Shubham Srivastava"], facultyHindi: ["प्रो. अजीत सिंह", "डॉ. शुभम श्रीवास्तव"] },
                        { day: "Tuesday", dayHindi: "मंगलवार", faculty: ["Prof. Amit Rastogi", "Prof. Shivam Sinha", "Dr. Birju Manjhi"], facultyHindi: ["प्रो. अमित रस्तोगी", "प्रो. शिवम सिन्हा", "डॉ. बिरजू मांझी"] },
                        { day: "Wednesday", dayHindi: "बुधवार", faculty: ["Dr. Abhijeet Kunwar", "Dr. Chanchal Singh"], facultyHindi: ["डॉ. अभिजीत कुँवर", "डॉ. चंचल सिंह"] },
                        { day: "Thursday", dayHindi: "गुरुवार", faculty: ["Dr. Sanjay Yadav", "Dr. Shubham Srivastava"], facultyHindi: ["डॉ. संजय यादव", "डॉ. शुभम श्रीवास्तव"] },
                        { day: "Friday", dayHindi: "शुक्रवार", faculty: ["Prof. Shivam Sinha", "Dr. Birju Manjhi"], facultyHindi: ["प्रो. शिवम सिन्हा", "डॉ. बिरजू मांझी"] },
                        { day: "Saturday", dayHindi: "शनिवार", faculty: ["Prof. Saurabh Singh", "Dr. Alok Rai"], facultyHindi: ["प्रो. सौरभ सिंह", "डॉ. आलोक राय"] },
                      ].map((item, index) => (
                        <tr key={index} className={`hover:bg-blue-50 transition-colors ${index !== 5 ? 'border-b border-gray-100' : ''}`}>
                          <td className="py-4 px-4">
                            <div className="font-medium text-gray-800">{item.day}</div>
                            <div className="text-gray-500 text-sm">{item.dayHindi}</div>
                          </td>
                          <td className="py-4 px-4">
                            <div className="space-y-1">
                              {item.faculty.map((name, idx) => (
                                <div key={idx} className="flex items-center">
                                  <ChevronRight size={16} className="text-blue-500 mr-1" />
                                  <div>
                                    <span className="text-gray-800">{name}</span>
                                    <span className="text-gray-500 text-sm ml-2">{item.facultyHindi[idx]}</span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
            {/* Plastic Surgery Department */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden transition-transform hover:shadow-lg">
              <div className="bg-gradient-to-r from-green-600 to-green-700 text-white p-5 relative">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-2xl font-bold">DEPARTMENT OF PLASTIC SURGERY</h3>
                    <p className="text-green-100 mt-1 font-medium">प्लास्टिक सर्जरी बहिरंग</p>
                  </div>
                  <div className="bg-white text-green-700 p-3 rounded-full shadow-lg">
                    <User size={24} />
                  </div>
                </div>
              </div>
              <div className="p-5">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead>
                      <tr className="bg-green-50 text-green-800">
                        <th className="py-3 px-4 text-left font-semibold rounded-l-lg border-b-2 border-green-100">
                          <div className="flex items-center space-x-2">
                            <Calendar size={18} />
                            <span>DAY (दिन)</span>
                          </div>
                        </th>
                        <th className="py-3 px-4 text-left font-semibold rounded-r-lg border-b-2 border-green-100">
                          <div className="flex items-center space-x-2">
                            <User size={18} />
                            <span>FACULTY (फैकल्टी)</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        { 
                          day: "Monday", 
                          dayHindi: "सोमवार", 
                          faculty: [
                            "1st & 5th - Prof. N. K. Aggarwal",
                            "2nd - Prof. Vaibhav Jain",
                            "3rd - Dr. Sudipta Bera",
                            "4th - Dr. Rohit Kumar Rai"
                          ], 
                          facultyHindi: [
                            "प्रो. एन.के. अग्रवाल",
                            "प्रो. वैभव जैन",
                            "डॉ. सुदीप्त बेरा",
                            "डॉ. रोहित कुमार राय"
                          ] 
                        },
                        { day: "Tuesday", dayHindi: "मंगलवार", faculty: ["Prof. N. K. Aggarwal"], facultyHindi: ["प्रो. एन.के. अग्रवाल"] },
                        { day: "Wednesday", dayHindi: "बुधवार", faculty: ["Dr. Sudipta Bera"], facultyHindi: ["डॉ. सुदीप्त बेरा"] },
                        { day: "Thursday", dayHindi: "गुरुवार", faculty: ["Dr. Umesh Kumar"], facultyHindi: ["डॉ. उमेश कुमार"] },
                        { day: "Friday", dayHindi: "शुक्रवार", faculty: ["Dr. Rohit Kumar Rai"], facultyHindi: ["डॉ. रोहित कुमार राय"] },
                        { day: "Saturday", dayHindi: "शनिवार", faculty: ["Prof. Vaibhav Jain"], facultyHindi: ["प्रो. वैभव जैन"] },
                      ].map((item, index) => (
                        <tr key={index} className={`hover:bg-green-50 transition-colors ${index !== 5 ? 'border-b border-gray-100' : ''}`}>
                          <td className="py-4 px-4">
                            <div className="font-medium text-gray-800">{item.day}</div>
                            <div className="text-gray-500 text-sm">{item.dayHindi}</div>
                          </td>
                          <td className="py-4 px-4">
                            <div className="space-y-2">
                              {item.faculty.map((name, idx) => (
                                <div key={idx} className="flex items-center">
                                  <ChevronRight size={16} className="text-green-500 mr-1" />
                                  <div>
                                    <span className="text-gray-800">{name}</span>
                                    <div className="text-gray-500 text-sm ml-5">{item.facultyHindi[idx]}</div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
            {/* Trauma General Surgery */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden transition-transform hover:shadow-lg">
              <div className="bg-gradient-to-r from-red-600 to-red-700 text-white p-5 relative">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-2xl font-bold">TRAUMA  GENERAL SURGERY</h3>
                    <p className="text-red-100 mt-1 font-medium">ट्रॉमा जनरल सर्जरी</p>
                  </div>
                  <div className="bg-white text-red-700 p-3 rounded-full shadow-lg">
                    <Clock size={24} />
                  </div>
                </div>
              </div>
              <div className="p-5">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead>
                      <tr className="bg-red-50 text-red-800">
                        <th className="py-3 px-4 text-left font-semibold rounded-l-lg border-b-2 border-red-100">
                          <div className="flex items-center space-x-2">
                            <Calendar size={18} />
                            <span>DAY (दिन)</span>
                          </div>
                        </th>
                        <th className="py-3 px-4 text-left font-semibold rounded-r-lg border-b-2 border-red-100">
                          <div className="flex items-center space-x-2">
                            <User size={18} />
                            <span>FACULTY (फैकल्टी)</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        { day: "Monday", dayHindi: "सोमवार", faculty: ["Prof. S. P. Mishra"], facultyHindi: ["प्रो. एस.पी. मिश्रा"] },
                        { day: "Wednesday", dayHindi: "बुधवार", faculty: ["Dr. Sumit Sharma"], facultyHindi: ["डॉ. सुमित शर्मा"] },
                        { day: "Thursday", dayHindi: "गुरुवार", faculty: ["Prof. S. K. Bhartiya"], facultyHindi: ["प्रो. एस.के. भारतीय"] },
                        { day: "Saturday", dayHindi: "शनिवार", faculty: ["Dr. Vivek Katiyar"], facultyHindi: ["डॉ. विवेक कटियार"] },
                      ].map((item, index) => (
                        <tr key={index} className={`hover:bg-red-50 transition-colors ${index !== 3 ? 'border-b border-gray-100' : ''}`}>
                          <td className="py-4 px-4">
                            <div className="font-medium text-gray-800">{item.day}</div>
                            <div className="text-gray-500 text-sm">{item.dayHindi}</div>
                          </td>
                          <td className="py-4 px-4">
                            <div className="space-y-1">
                              {item.faculty.map((name, idx) => (
                                <div key={idx} className="flex items-center">
                                  <ChevronRight size={16} className="text-red-500 mr-1" />
                                  <div>
                                    <span className="text-gray-800">{name}</span>
                                    <span className="text-gray-500 text-sm ml-2">{item.facultyHindi[idx]}</span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
          {/* Info Card */}
          <div className="mt-12 bg-blue-50 rounded-lg p-6 text-center shadow-sm border border-blue-100">
            <h3 className="text-lg font-bold text-blue-800 mb-2">Hospital Information</h3>
            <p className="text-blue-700 mb-1">Trauma Centre & Superspecialty Hospital</p>
            <p className="text-blue-600">An Institution of National Importance established by an Act of Parliament</p>
            <p className="text-blue-600">Institute of Medical Sciences</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OpdSchedule;